import { render, staticRenderFns } from "./PropertyUnitBlock.vue?vue&type=template&id=2e794c76&scoped=true&"
import script from "./PropertyUnitBlock.vue?vue&type=script&lang=js&"
export * from "./PropertyUnitBlock.vue?vue&type=script&lang=js&"
import style0 from "./PropertyUnitBlock.vue?vue&type=style&index=0&id=2e794c76&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e794c76",
  null
  
)

export default component.exports